import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { BackgroundLoading } from '@components/Loading';
import RouteChangeTracker from '@components/routeChangeTracker';
import FooterV2 from '@layout/footer/FooterV2';
import Header from '@layout/header';
import Loader from '@layout/loader';
import PageBody from '@layout/page/PageBody';
import { SideBar2 } from '@layout/sidebar/index';
import { getMerchantInfo, merchantId_api } from '@lib/api';
import { getMerchantKioskVersion } from '@lib/api/v2/merchant';
import { getInfo } from '@lib/api/v2/user';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useHandleError from '@lib/hooks/useHandleError';
import useWindow from '@lib/hooks/useWindow';
import { connectSocket, disconnectSocket, joinRoom } from '@lib/socket';
import useAppStore from '@store/useAppStore';
import { getAllToken } from '@util/token';

const App = ({ children, isLoading }) => {
  const windowSize = useWindow();
  const { createRequest } = useHandleAPICall();
  const { catchError } = useHandleError();
  const ScreenType = useMemo(() => {
    if (!windowSize || !windowSize.actualWidth) return 'desktop';
    if (windowSize.actualWidth >= 1280) return 'desktop';
    if (windowSize.actualWidth >= 768) return 'tablet';
    return 'mobile';
  }, [windowSize]);

  const isMobile = useMemo(() => {
    if (!windowSize) return false;
    return windowSize.width && windowSize.width < 1280;
  }, [windowSize]);
  // const [merchantData, setMerchantData] = useState({});
  const [mid, setMid] = useState({});

  const { merchantData, setMerchantData, userPhoneNumber, setMerchantKioskVersion } = useAppStore();
  const [isShowSide, setIsShowSide] = useState(false);

  useEffect(() => {
    getMerchantId();
  }, []);

  // merchantData가 로드되면 소켓 연결 및 방 입장
  useEffect(() => {
    if (!merchantData?.id) return;

    // 연결 완료 후 방 입장
    connectSocket(() => {
      joinRoom(merchantData.id);
    });

    // 컴포넌트 언마운트 시 소켓 연결 해제
    return () => {
      disconnectSocket();
    };
  }, [merchantData?.id]);

  const { userToken, merchantToken, adminToken } = getAllToken();
  const level = localStorage.getItem('level');

  const UserType = useMemo(() => {
    return {
      admin: adminToken && !merchantToken,
      adminMerchant: !!merchantToken && !!adminToken,
      merchantUserV1: !!merchantToken && !userToken && !!userPhoneNumber,
      merchantUserV2: !!merchantToken && !!userToken,
      userV2: !!userToken && !merchantToken,
      merchant: !!merchantToken && !userToken,
    };
  }, [userToken, merchantToken, adminToken, userPhoneNumber]);

  const getMerchantId = async () => {
    try {
      const htmlTitle = document.querySelector('title');
      const parsedPhoneNumber =
        userPhoneNumber && userPhoneNumber.length > 4 ? userPhoneNumber.slice(-4) : '';
      if (UserType.merchantUserV1 || UserType.merchantUserV2) {
        const { data } = await createRequest(getInfo);
        setMerchantData({ ...data });
        return;
      }
      if (UserType.adminMerchant) {
        const { data } = await createRequest(getInfo);

        setMid(data.merchantId);
        const res = await createRequest(getMerchantInfo, data.merchantId);
        setMerchantData({ ...res.data[0], id: data.merchantId });
        htmlTitle.innerText = `렛미업 스터디카페 키오스크 - ${res.data[0].name} 관리페이지`;
        try {
          const kioskVersionData = await createRequest(getMerchantKioskVersion);
          const { outerVersion } = kioskVersionData.data;
          const version = outerVersion.split('.');
          setMerchantKioskVersion(parseInt(version[0]));
        } catch (error) {
          setMerchantKioskVersion(1);
        }
        return;
      }

      // 지점 및 관리자 로그인
      if (!UserType.userV2 && !UserType.admin)
        try {
          const { data } = await createRequest(merchantId_api);
          const kioskVersionData = await createRequest(getMerchantKioskVersion);
          const { outerVersion } = kioskVersionData.data;
          const version = outerVersion.split('.');
          setMerchantKioskVersion(parseInt(version[0]));
          setMid(data.id);
          const res = await createRequest(getMerchantInfo, data.id);
          setMerchantData({ ...res.data[0], id: data.id, phoneNum: userPhoneNumber || '' });
          if (UserType.adminMerchant || UserType.merchant)
            htmlTitle.innerText = `렛미업 스터디카페 키오스크 - ${res.data[0].name} 관리페이지`;
          return;
        } catch (error) {
          setMerchantKioskVersion(1);
        }

      htmlTitle.innerText = `렛미업 스터디카페 키오스크${
        parsedPhoneNumber ? ` - ${parsedPhoneNumber}` : ''
      }`;
    } catch (err) {
      catchError(err);
    }
  };

  RouteChangeTracker();

  return (
    <Fragment>
      <Loader />
      {isLoading && <BackgroundLoading />}
      {/* {UserType.admin && (
        <div
          onClick={() => {
            if (localStorage.getItem('isClick')) {
              const selected = document.querySelector('.onhover-show-div');
              if (!selected) return;
              document.querySelector('.onhover-show-div').classList.remove('showing');
              localStorage.setItem('isClick', false);
            }
          }}
          className="page-body-wrapper sidebar-icon">
          <SideBar2 isShowSide={isShowSide} setIsShowSide={setIsShowSide} />
          <div className="page-body" isLoading merchantData={merchantData}>
            {children}
          </div>
        </div>
      )} */}
      {/* {!UserType.admin && ( */}
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        {/* {!UserType.admin && ( */}
        <Header
          isMobile={isMobile}
          screenType={ScreenType}
          data={merchantData}
          mid={mid}
          isShowSide={isShowSide}
          setIsShowSide={setIsShowSide}
        />
        {/* )} */}

        <div
          onClick={() => {
            if (localStorage.getItem('isClick')) {
              const selected = document.querySelector('.onhover-show-div');
              if (!selected) return;
              document.querySelector('.onhover-show-div').classList.remove('showing');
              localStorage.setItem('isClick', false);
            }
          }}
          className="page-body-wrapper sidebar-icon">
          {/* <Sidebar/> */}
          <SideBar2 isShowSide={isShowSide} setIsShowSide={setIsShowSide} isMobile={isMobile} />
          {/* <div className="page-body" isLoading merchantData={merchantData}> */}
          <PageBody>{children}</PageBody>

          {/* </div> */}
          {level === 'merchant' && <FooterV2 data={merchantData} isMobile={isMobile} />}
          {/* <ThemeCustomize /> */}
        </div>
      </div>
      {/* )} */}
    </Fragment>
  );
};

export default App;
